import {
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Checkbox,
  ListItemText,
  SelectProps,
} from "@mui/material";
import { useCallback } from "react";
import { ANALYST_RFPS_STATUSES } from "@platform/rfp-core";

import { RFP_STATUSES } from "../constants/rfp";

const MenuProps = {
  PaperProps: {
    style: {
      width: 250,
    },
  },
};

type RfpStatusFilterProps = {
  currStatus: string[];
  setCurrStatus: (value: string[]) => void;
  selectProps?: Omit<SelectProps<string[]>, "value" | "variant" | "MenuProps">;
  options: typeof RFP_STATUSES | typeof ANALYST_RFPS_STATUSES;
};

export const RfpStatusFilter: React.FC<RfpStatusFilterProps> = ({
  currStatus,
  setCurrStatus,
  selectProps,
  options,
}) => {
  const handleChangeStatus: SelectProps<string[]>["onChange"] = useCallback(
    (event) => {
      const { value } = event.target;

      // Value contains the camelCase keys (API values), not display values
      setCurrStatus(
        typeof value === "string" ? value.split(",") : (value as string[]),
      );
    },
    [setCurrStatus],
  );

  return (
    <FormControl sx={{ width: "75%" }}>
      <InputLabel id="filterStatus-label">Filter By Status</InputLabel>
      <Select<string[]>
        labelId="filterStatus-label"
        id="filterStatus"
        value={currStatus}
        onChange={handleChangeStatus}
        input={<OutlinedInput label="Filter By Status" />}
        renderValue={(selected) =>
          (selected as string[])
            .map((key) => options[key as keyof typeof options])
            .join(", ")
        }
        MenuProps={MenuProps}
        {...selectProps}
      >
        {Object.entries(options).map(([key, displayValue]) => (
          <MenuItem key={key} value={key}>
            <Checkbox checked={currStatus.includes(key)} />
            <ListItemText primary={displayValue} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
